/* app/js/src/components/broadcast/broadcast-editor/broadcast-editor-audio-mixer/broadcast-editor-audio-mixer.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.channels-container::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.channels-container::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.channels-container::-webkit-scrollbar-corner {
  background: transparent;
}
.channels-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.channels-container::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.channels-container::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.channels-container::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.channels-container::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
:host {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  width: 100%;
  height: 100%;
  -webkit-user-select: none;
  user-select: none;
}
.header {
  border-bottom: clamp(0.0625rem, 0.0625rem + 0.01vw, 0.125rem) solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: clamp(0.25rem, 0.25rem + 0.25vw, 0.5rem) clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  width: 100%;
  flex: 0 0 1.6rem;
}
.header .header-title {
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.125rem;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.9);
  margin: 0;
}
.indicators {
  border-bottom: clamp(0.0625rem, 0.0625rem + 0.01vw, 0.125rem) solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: clamp(0.1875rem, 0.1875rem + 0.125vw, 0.375rem) clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  width: 100%;
  flex: 0 0 1.4rem;
}
.indicators .headphones-placeholder {
  width: clamp(1rem, 1rem + 1vw, 2rem);
  height: clamp(1rem, 1rem + 1vw, 2rem);
}
.indicators .db-scale {
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1rem;
  color: rgba(0, 0, 0, 0.9);
}
.indicators .db-scale .db-value {
  position: absolute;
}
.indicators .db-scale :nth-child(1) {
  left: -1%;
}
.indicators .db-scale :nth-child(2) {
  left: 15.6667%;
}
.indicators .db-scale :nth-child(3) {
  left: 33.3333%;
}
.indicators .db-scale :nth-child(4) {
  left: 50%;
}
.indicators .db-scale :nth-child(5) {
  left: 68%;
}
.indicators .db-scale :nth-child(6) {
  left: 86%;
}
.channels-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex: 0 0 17rem;
}
@media (min-width: 2000px) {
  .channels-container {
    flex: 0 0 27rem;
  }
}
.channel {
  display: flex;
  align-items: center;
  width: 100%;
  border-bottom: clamp(0.0625rem, 0.0625rem + 0.01vw, 0.125rem) solid rgba(0, 0, 0, 0.1);
  border-left: clamp(0.25rem, 0.25rem + 0.25vw, 0.5rem) solid transparent;
  padding: 0;
}
.channel.master-channel {
  height: auto;
  min-height: clamp(2.875rem, 2.875rem + 2vw, 5.75rem);
}
.channel.camera-channel,
.channel.commentator-channel,
.channel.production-channel,
.channel.feed-channel {
  height: clamp(2.875rem, 2.875rem + 2vw, 5.75rem);
}
.channel-icon-container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  padding: 0 clamp(0.3125rem, 0.3125rem + 0.25vw, 0.625rem) clamp(0.3125rem, 0.3125rem + 0.25vw, 0.625rem) clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  height: 100%;
  min-width: 2.7rem;
  flex-shrink: 0;
  position: relative;
  gap: clamp(0.5rem, 0.5rem + 0.125vw, 1rem);
  top: clamp(0.1875rem, 0.1875rem + 0.125vw, 0.375rem);
}
.channel-icon-container .cursor-pointer {
  cursor: pointer;
}
.channel-icon-container .cursor-not-allowed {
  cursor: not-allowed;
}
.channel-icon-container .three-dots-icon {
  cursor: pointer;
}
.channel-icon-container .three-dots-icon svg path {
  fill: rgb(0, 0, 0);
  fill-opacity: 1;
}
.channel-icon-container .three-dots-icon.disabled {
  cursor: default;
}
.channel-icon-container .three-dots-icon.disabled svg path {
  fill: rgba(0, 0, 0, 0.6);
  fill-opacity: 0.6;
}
.channel-controls {
  display: flex;
  flex-direction: column;
  gap: clamp(0.125rem, 0.125rem + 0.125vw, 0.25rem);
  align-items: flex-start;
  justify-content: center;
  width: 13.15rem;
  flex-shrink: 0;
}
.channel-controls .channel-name {
  display: flex;
  align-items: center;
}
.channel-controls .channel-name p {
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1rem;
  color: rgba(0, 0, 0, 0.9);
  margin: 0;
  outline: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.channel-controls .channel-name p[contenteditable=true] {
  cursor: text;
}
.channel-controls .channel-name p[contenteditable=true]:focus {
  outline: 1px solid rgba(0, 0, 0, 0.2);
  outline-offset: 2px;
  border-radius: 2px;
}
.channel-controls .channel-name p[contenteditable=true]:hover:not(:focus) {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 2px;
}
.channel-controls .channel-name p[contenteditable=false] {
  cursor: default;
}
.channel-controls .volume-controls {
  display: flex;
  flex-direction: column;
  gap: clamp(0.1875rem, 0.1875rem + 0.125vw, 0.375rem);
  align-items: flex-start;
  width: 100%;
}
.channel-controls .volume-controls .volume-bars {
  display: flex;
  gap: clamp(0.0625rem, 0.0625rem + 0.01vw, 0.125rem);
  align-items: flex-start;
  width: 100%;
}
.channel-controls .volume-controls .volume-bars .volume-bar {
  height: clamp(0.3125rem, 0.3125rem + 0.25vw, 0.625rem);
  width: 0.095rem;
  flex-shrink: 0;
}
.channel-controls .volume-controls .slider-container {
  position: relative;
  bottom: 0.5rem;
  width: 100%;
  height: clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  margin-top: clamp(0.1875rem, 0.1875rem + 0.125vw, 0.375rem);
}
.channel-controls .volume-controls .slider-container .slider-track {
  position: absolute;
  top: clamp(0.1875rem, 0.1875rem + 0.125vw, 0.375rem);
  left: 0;
  width: 100%;
  height: clamp(0.09375rem, 0.09375rem + 0.1vw, 0.1875rem);
  background-color: #232f3a;
  border-radius: 100px;
}
.channel-controls .volume-controls .slider-container .slider-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
  -webkit-appearance: none;
  appearance: none;
}
.channel-controls .volume-controls .slider-container .slider-input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: clamp(0.279rem, 0.279rem + 0.25vw, 0.558rem);
  height: clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  cursor: pointer;
}
.channel-controls .volume-controls .slider-container .slider-input::-moz-range-thumb {
  width: clamp(0.279rem, 0.279rem + 0.25vw, 0.558rem);
  height: clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  cursor: pointer;
  border: none;
}
.channel-controls .volume-controls .slider-container .slider-handle {
  position: absolute;
  top: 0;
  width: clamp(0.279rem, 0.279rem + 0.25vw, 0.558rem);
  height: clamp(0.5rem, 0.5rem + 0.5vw, 1rem);
  background-color: #232f3a;
  border-radius: clamp(0.0625rem, 0.0625rem + 0.01vw, 0.125rem);
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 1;
}
.channel-spacer {
  width: clamp(3.625rem, 3.625rem + 3.5vw, 7.25rem);
  height: 100%;
  flex-shrink: 0;
}
.channel-actions {
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
}
.channel-actions .action-icon {
  display: flex;
  align-items: flex-end;
  height: 100%;
  padding: 0 clamp(0.5rem, 0.5rem + 0.5vw, 1rem) clamp(0.3125rem, 0.3125rem + 0.25vw, 0.625rem) clamp(0.3125rem, 0.3125rem + 0.25vw, 0.625rem);
  cursor: pointer;
}
.channel-actions .action-icon img {
  width: clamp(1rem, 1rem + 1vw, 2rem);
  height: clamp(1rem, 1rem + 1vw, 2rem);
  display: block;
  max-width: 100%;
}
.context-menu {
  position: fixed;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  min-width: 120px;
  padding: 4px 0;
}
.context-menu__item {
  padding: 8px 12px;
  cursor: pointer;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  color: #333;
}
.context-menu__item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
:host-context(.mam-collapsed) .channels-container {
  flex: 0 0 20.875rem;
}
@media (min-width: 2000px) {
  :host-context(.mam-collapsed) .channels-container {
    flex: 0 0 35rem;
  }
}
/*# sourceMappingURL=broadcast-editor-audio-mixer.component.css.map */
